import { render, staticRenderFns } from "./Customer-settings.vue?vue&type=template&id=50c30149&scoped=true&"
import script from "./Customer-settings.vue?vue&type=script&lang=js&"
export * from "./Customer-settings.vue?vue&type=script&lang=js&"
import style0 from "./Customer-settings.vue?vue&type=style&index=0&id=50c30149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c30149",
  null
  
)

export default component.exports